export function getLocale(): string {
    const parts = window.location.pathname.split('/');
    const locale = parts[1];
    return locale || 'de'; // fallback
}
